module.exports = __webpack_public_path__ + "img/ageIcon.5d28707e.svg";